var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotionSensor01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.26,11.36H1.74V5.03h12.53V11.36z M2.24,10.86h11.53V5.53H2.24V10.86z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.55,8.23C7.52,7.71,7.49,7.08,7.49,6.62H7.47C7.35,7.06,7.19,7.52,7,8.04L6.35,9.85H5.98l-0.6-1.78 C5.2,7.54,5.05,7.06,4.94,6.62H4.93C4.92,7.08,4.89,7.71,4.86,8.27l-0.1,1.6H4.3l0.26-3.73h0.61l0.64,1.81 C5.97,8.4,6.1,8.81,6.19,9.2h0.02C6.3,8.82,6.43,8.41,6.6,7.94l0.66-1.81h0.62l0.23,3.73H7.64L7.55,8.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.56,9.28c0.22,0.13,0.53,0.24,0.86,0.24c0.49,0,0.78-0.26,0.78-0.64c0-0.35-0.2-0.55-0.7-0.74 C9.89,7.93,9.52,7.62,9.52,7.09c0-0.58,0.48-1.01,1.21-1.01c0.38,0,0.66,0.09,0.83,0.18l-0.13,0.39 c-0.12-0.07-0.37-0.18-0.71-0.18c-0.51,0-0.7,0.3-0.7,0.56c0,0.35,0.23,0.52,0.74,0.72C11.38,8,11.7,8.3,11.7,8.85 c0,0.58-0.43,1.08-1.31,1.08c-0.36,0-0.75-0.11-0.95-0.24L9.56,9.28z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionSensor01);
export default __webpack_public_path__ + "static/media/MotionSensor-01.1f4b9a3c923942a659f02ba48ff2dd50.svg";
export { ForwardRef as ReactComponent };